import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FadeIn from "react-fade-in";
import axios from "axios";

import ExerciseCard from "../../../../InterstellrComponents/ExerciseCard";
import ExerciseVideoPopup from "../../../sub-components/employeeSub/ExerciseVideoPopup";
import { GET_CATEGORY_EXERCISES } from "../../../../Routes";
import { generateURLOptions } from "../../../../URLOptions";
import { UserContext } from "../../../../storage/contexts/UserContext";

import { FaChevronLeft } from "react-icons/fa6";

const SingleExerciseCategory = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { profile } = useContext(UserContext);

  const [visible, setVisible] = useState(true);

  const [exercises, setExercises] = useState([]);

  const [selectedVideo, setSelectedVideo] = useState({});
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);

  useEffect(() => {
    console.log(state);

    if (state.categoryId) {
      getExercises();
    }
  }, []);

  const getExercises = async () => {
    await axios
      .get(GET_CATEGORY_EXERCISES + state?.categoryId, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        console.log("Exercise Category Data: ", response);
        setExercises(response.data?.data);
      })
      .catch((error) => {
        console.log("Get Exercise Category Data Error: ", error);
        return alert(error);
      });
  };

  const handleVideoPopupOnClick = (item) => {
    console.log("Video Popup Invoked");
    console.log(item);
    setIsVideoPopupOpen(true);
    setSelectedVideo(item);
  };

  const handlePopupOnCloseClick = () => {
    setIsVideoPopupOpen(false);
  };

  const navigateBack = () => {
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/exercises");
    }, 350);
  };

  return (
    <>
      {isVideoPopupOpen && (
        <ExerciseVideoPopup
          key={selectedVideo._id}
          item={selectedVideo}
          isOpen={isVideoPopupOpen}
          closeModal={handlePopupOnCloseClick}
        />
      )}

      <div
        className="w-screen min-h-[90vh]"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <FadeIn delay={200} visible={visible}>
          <div className="container mx-auto flex flex-col justify-start items-center h-full w-full">
            <div className="mt-12 w-full px-6 md:px-0">
              <h4 className="text-xl md:text-2xl font-semibold">
                {exercises?.name ?? "Eat well 🍎"}
              </h4>

              <div
                onClick={navigateBack}
                className="flex flex-row justify-start items-center cursor-pointer mt-2"
              >
                <FaChevronLeft />
                <p className="text-black font-medium text-sm ml-2">Back</p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-6">
                {exercises?.exercises?.map((exercise) => (
                  <ExerciseCard
                    key={exercise._id}
                    exercise={exercise}
                    onClick={handleVideoPopupOnClick}
                  />
                ))}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </>
  );
};

export default SingleExerciseCategory;
